<template>
  <SideNav />




  <header>
    <div
      class="page-header min-vh-50 "
      style="background-image: url('assets/img/tronbmms1.jpg');"
    >
      <span class="mask bg-black opacity-5" />
    </div>
    <div class="position-relative">                    
      <div class="position-absolute w-md-60 z-index-3  d-md-none bottom-80">
        <img
          class="img-fluid px-4"
          src="assets/img/tronbmms2.png"
        >
      </div> 
      <div class="container px-md-0 position-relative">        
        <div class="col-12 col-xl-7 position-md-absolute end-0 top-n25 w-md-70 order-1 order-md-2  z-index-3  d-none d-md-block move-on-hover">
          <img
            class="w-100"
            src="assets/img/tronbmms2.png"
            alt="macbook"
            loading="lazy"
          >
        </div>
        <div class="bg-gradient-success position-relative pt-5 pb-4 py-md-3 py-lg-4  z-index-2 border-radius-xl mt-n7 mt-sm-n10 mt-md-n12  overflow-hidden">
          <img
            src="assets/img/shapes/pattern-lines.svg"
            alt="pattern-lines"
            class="position-absolute opacity-6 start-0 top-0 w-100"
            loading="lazy"
          >
          <div class="px-3 px-md-5 position-relative">
            <div class="row justify-content-between align-items-center">
              <div class="col-12 col-xl-5 text-center text-md-start  position-relative order-2 order-md-1 pt-4 py-sm-5">
                <div class="position-relative">
                  <h3 class="text-white mt-sm-0 mb-3">
                    TronMap
                    <br>
                    Intelligence Drawing
                    <br>
                    <br class="d-none d-md-block d-lg-none"> 創益圖智慧繪圖
                  </h3>
                  <p class="text-white mb-3">
                    ParkDraw 智慧園區繪圖系統<br>
                    ParkMeta 智慧園區元宇宙系統<br>
                    BuildDraw 智慧建築繪圖系統<br>
                    BuildMeta 智慧建築元宇宙系統<br>
                  </p>
                  <button
                    type="button"
                    class="btn bg-gradient-dark btn-lg me-3 mt-3"
                  >
                    <i class="material-icons me-2">menu_book</i>技術支援
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>


  <div class="py-5 pt-lg-0 pb-lg-6 container px-0">
    <div class="p-3 info-hoversuccess text-center mb-4 mt-md-6">
      <div class="icon icon-shape bg-gradient-success shadow icon-shape-circle text-success">
        <i
          class="fa fa-cube  opacity-10"
          aria-hidden="true"
        />
      </div>
    </div>
    <h4 class="mb-4 text-center mb-6">
      TronMap 創益圖系列產品介紹
    </h4>
    <div class="row align-items-center mx-0">
      <div class="mx-auto col-md-6 order-2 order-md-1">
        <p class="text-dark lh-lg">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
          TronMap Intelligence Drawing 智慧繪圖系列產品中的雲平台 BMMS Platform v2.0 採用容器化微服務架構支援公有、私有、 混合雲，
          我們的研發團隊研發出多種「繪圖動畫引擎模組」並申請及擁有該產品相關多項專利可在沉浸GIS元宇宙的地球、城市、園區、建築、平面樓層上繪製
          建築、樓層、空間、設備、設施、交通、家俱、人員等3D/2D物件，
          繪圖的過程會將繪圖物件衛星座標同步到雲端資料庫（精準度達小數點 14 位）。
          <br>
          設備挷定模組;可將繪圖物件與AIOT設備連結挷定顯示、警示、控制、GPS、移動、測試、報表、影像等單元，
          本產品可以應用在國防、安防、消防、軍警、旅遊、建設、製造、智慧城市、智慧園區、智慧工廠、智慧建築、作戰指揮、逃生模擬、ESG、EMS、資產、資安、違規取締等應用服務。
        </p>
      </div>
      <div class="col-md-6 order-1 order-md-2 mb-5 mb-md-0 ms-auto">
        <img
          src="assets/img/TronMap1.jpg"
          class="img-fluid rounded shadow-lg"
        >
      </div>
    </div>


    <div class="row align-items-center mx-0 mb-0 py-6">
      <div class="mx-auto col-lg-12 order-1 order-lg-12  mb-5 mb-lg-0">
        <img
          src="assets/img/TronMap2.png"
          class="img-fluid rounded shadow-lg"
        >
      </div>
    </div>



        
    <section class="pt-5 pt-lg-4">
      <div class="container px-0">
        <div class="">
          <div class="col-lg-8 ms-auto me-auto text-center">
            <div class="p-3 info-hover-warning mb-4">
              <div class="icon icon-shape bg-gradient-success shadow icon-shape-circle text-success">
                <i
                  class="fa fa-network-wired opacity-10"
                  aria-hidden="true"
                />
              </div>
            </div>
            <h4 class="card-title mb-4">
              <a class="text-dark">產品規格</a>
            </h4>
            <p class="card-description  mb-4">
              TronMap Intelligence Drawing 智慧繪圖系列產品
              主平台為園區建築管理平台（BMMS Platform v2.0），
              園區繪圖系統（ParkDraw）、
              建築繪圖系統（BuildDraw）、
              園區元宇宙平台（ParkMeta）、
              智慧建築元宇宙平台（BuildMeta）
              等系統平台
              系統全面採用容器化微服務架構有著高度的可靠性（Reliability）、可用性（Availability）、可維護性（Serviceability）使用者可彈性選擇授權或訂閱制方案。
            </p>
          </div>
        </div>


        <div class="row align-items-center mx-0 mb-5">
          <div class="col-xl-6 mb-5">
            <img
              src="assets/img/bmms22.jpg"
              class="img-fluid rounded shadow-lg"
            >
          </div>            
          <div class="col-xl-6 mt-lg-0 mt-5 ps-lg-0 ps-0">
            <div class="p-3 info-horizontal">
              <div class="d-flex align-items-center mb-2"> 
                <div> 
                  <div class="icon icon-shape  bg-gradient-success text-center rounded-pill shadow-none">
                    <i
                      class="fas fa-spell-check opacity-10 text-lg"
                      aria-hidden="true"
                    />
                  </div>
                </div>
                <div class="ms-3"> 
                  <h5 class="mb-0 ">
                    關鍵痛點/解決方案
                  </h5>
                  <span class="text-normal  text-info">Pain Point/Solution</span>
                </div>
              </div>
              <div class="description ps-5">
                <ul class="mb-0">
                  <li class="mb-3">
                    數位孿生、智慧園區、VR 、綠色園區(ESG)等議題及應用在建置元宇宙時需要投入高額及大量的人力成本與時程且相關專業人材也不易招募，有些太依賴軟體及3D團隊的大型工程(例如:智慧工廠)甚至施工長達數年交付品質粗糙且無法結案最後宣告導入失敗。
                  </li>
                  <li class="mb-3">
                    TronMap Intelligence Drawing 提供高品質動畫繪圖渲染技術在所見即所得沉浸式元宇宙體驗工作模式下無需數年僅需幾天即可完成高品質的工程，只要會打電動不需要會寫程式即可投入建置、維運、管理等工作，大幅度降低導入失敗的風險及門檻。
                  </li>
                </ul>
              </div>
            </div>              
            <div class="p-3 info-horizontal">
              <div class="d-flex align-items-center mb-2"> 
                <div> 
                  <div class="icon icon-shape  bg-gradient-success text-center rounded-pill shadow-none">
                    <i
                      class="fas fa-photo-film-music opacity-10 text-lg"
                      aria-hidden="true"
                    />
                  </div>
                </div>
                <div class="ms-3">
                  <h5 class="mb-0">
                    智慧園區繪圖系統/元宇宙系統（ParkDraw / ParkMeta）
                  </h5>                
                  <span class="text-normal  text-info">Park Drawing / Park Metaverse</span>
                </div>
              </div>
              <div class="description ps-5">
                <ul class="mb-0">
                  <li class="mb-3">
                    圖資導覽模組、
                    建築繪圖物件模組、
                    設備繪圖物件模組、
                    設施繪圖物件模組、
                    交通繪圖物件模組、
                    人員繪圖物件模組、
                    物件屬性模組
                  </li>
                </ul>
              </div>
            </div>
          </div>        
        </div>
        <div class="row align-items-center mx-0 mb-6">
          <div class="col-lg-5  order-2 order-lg-1">
            <div class="p-3 info-horizontal">
              <div class="d-flex align-items-center mb-2"> 
                <div>
                  <div class="icon icon-shape  bg-gradient-success text-center rounded-pill shadow-none">
                    <i
                      class="fas fa-laptop-file opacity-10 text-lg"
                      aria-hidden="true"
                    />
                  </div>
                </div>
                <div class="ms-3">
                  <h5 class="mb-0">
                    智慧建築繪圖系統/元宇宙系統（BuildDraw / BuildMeta）
                  </h5>                
                  <span class="text-normal  text-info">Build Drawing / Build Metaverse</span>
                </div>
              </div>
              <div class="description ps-5">
                <ul class="mb-0">
                  <li class="mb-3">
                    樓層格局3D建模模組、
                    大樓建築生成模組、
                    空間物件繪圖模組、
                    家俱物件繪圖模組、
                    設施物件繪圖模組、
                    設備物件繪圖模組、
                    人員物件繪圖模組、
                    物件屬性模組
                  </li>
                </ul>
              </div>
            </div> 
            <div class="p-3 info-horizontal">
              <div class="d-flex align-items-center mb-2"> 
                <div>
                  <div class="icon icon-shape  bg-gradient-success text-center rounded-pill shadow-none">
                    <i
                      class="fas fa-cloud-question opacity-10 text-lg"
                      aria-hidden="true"
                    />
                  </div>
                </div>
                <div class="ms-3">
                  <h5 class="mb-0">
                    AIOT 設備模組
                  </h5>                
                  <span class="text-normal  text-info">AIOT Device Object Module</span>
                </div>  
              </div>
              <div class="description ps-5">
                <ul class="mb-0">
                  <li class="mb-3">
                    AIOT 設備模組、
                    廣播通訊模組、
                    AIOT 挷定模組
                  </li>
                </ul>
              </div>
            </div> 
          </div>     
          <div class="mx-auto col-lg-7 order-1 order-lg-2  mb-5 mb-lg-0">
            <img
              src="assets/img/bmms25.jpg"
              class="img-fluid "
            >
          </div> 
        </div>
        <!--   
        <div class="row align-items-center mx-0 mb-5">
          <div class="mx-auto col-md-6 mb-4 mb-lg-0 pe-lg-4">
            <img
              src="assets/img/bmms24.jpg"
              class="img-fluid rounded shadow-lg"
            >
          </div>   
          <div class="col-lg-6 ">
            <div class="p-3 info-horizontal">
              <div class="d-flex align-items-center mb-2"> 
                <div>
                  <div class="icon icon-shape  bg-gradient-success text-center rounded-pill shadow-none">
                    <i
                      class="fas fa-box-taped opacity-10 text-lg"
                      aria-hidden="true"
                    />
                  </div>
                </div>
                <div class="ms-3">
                  <h5 class="mb-0">
                    智能繪圖助理平台
                  </h5>                
                  <span class="text-normal  text-info">AI Drawing Platform</span>
                </div>  
              </div>
              <div class="description ps-5">
                <ul class="mb-0">
                  <li class="mb-3">
                    提供智能園區繪圖模組、智能3D建模模組、智能園區管理助理模組等服務。
                  </li>
                </ul>
              </div>
            </div>             
            <div class="p-3 info-horizontal">
              <div class="d-flex align-items-center mb-2"> 
                <div>
                  <div class="icon icon-shape  bg-gradient-success text-center rounded-pill shadow-none">
                    <i
                      class="fas fa-gear-complex-code opacity-10 text-lg"
                      aria-hidden="true"
                    />
                  </div>
                </div>
                <div class="ms-3">
                  <h5 class="mb-0">
                    智能繪圖助理訓練平台
                  </h5>                
                  <span class="text-normal  text-info">AI Drawing Training Platform</span>
                </div>  
              </div>
              <div class="description ps-5">
                <ul class="mb-0">
                  <li class="mb-3">
                    提供智能園區繪圖訓練模組、智能3D建模訓練模組、智能園區管理助理訓練模組等訓練AI模型服務。
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
-->
      </div>
    </section>
  </div>




  <!-- -------- START Features w/ 4 infos - just colored icons -------- -->

  <footer class="footer mt-5">
    <div class="container">
      <div class=" row align-items-center">
        <div class="col-md-6 mb-md-4 me-auto">
          <div class="d-none d-md-block">
            <a 
              href="javascript:;"
              @click="goToPage('/')"
            >
              <img
                src="assets/img/logo4.svg"
                class="mb-3"
                style="width: 160px;"
              >
            </a>
          </div>
        </div>

        <div class="col-md-6 mb-md-4 ms-auto text-center text-md-end">
          <a class="mb-3"><img
            src="assets/img/logo4.svg"
            style="width: 160px;"
            class="mb-3 d-md-none"
          ></a>

          <p class="mb-1">
            service@cloudraise.com
          </p>
          <p class="mb-1">
            新北市三重區重新路五段609巷14號5樓之3
          </p>
          <p class="mb-1">
            02-29992891
          </p>
        </div>
        <div class="col-12">
          <div class="text-center">
            <p class="text-dark my-2 my-md-4 text-sm font-weight-normal">
              Copyright ©
              2023
              by Cloud Raise Technology.
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
/* eslint-disable import/no-absolute-path */
// eslint-disable-next-line import/no-unresolved
import { config } from '@/include/config';
import {
  h,
  ref,
  toRefs,
  reactive,
  watch,
  inject,
  onMounted,
  onBeforeUpdate,
  onUpdated
} from 'vue';
import { oltConsole, oAA , oAuth, oApiError , oFrame } from '@/lib/oltModule/initOltVue3';
import { SideNav , Header , ProductHeader , Footer } from '@/components/Frame';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';

export default {
  name: 'App',
  components: {
    SideNav,
    //Header,
    //ProductHeader,
    //NavBar,
    // Settings,
    //Footer,
  },
  setup() {

    /**
     *  swal start
     */
    const swal = inject('$swal');
    /**
     *  swal end
     */

    const router = useRouter();
    const route = useRoute();
    const store = useStore();

    const nid = ref();

    //console.log('router.currentRoute.value : ', router.currentRoute.value.query);
    /*
    if(router.currentRoute.value.query.nid == null || router.currentRoute.value.query.nid == '' ){
      swal.fire({
        icon:'error',
        html:'路徑錯誤！！',
        buttonsStyling: true,
        confirmButtonClass: 'md-button md-success',
        //confirmButtonText:t('messages.confirm_button'),
      }).then( result => {
        if (result.value) {
          //console.log('result : ' , result);
          //emit('addCallBack');
          //router.go(-1);
          goToPage('/');
        }
      });
    }
	*/
    nid.value= router.currentRoute.value.query.nid ; 

    //console.log('nid' , nid.value);

    onMounted(async () => {
      chkLogin();
    });
    // Reload MDInput End

    onUpdated(async () => {
      // 修改 VUE 時 必需全部強制關閉 Modals 
      // eslint-disable-next-line no-undef
      //await oAdminFrame.closeAllModals() ;
    }) ;
    function goToPage(page){
      router.push( { path: page } );
    }


    function chkLogin(){
      let isLogin = oAuth.isLogin(store);

      if(!isLogin){
        //router.push({ path: '/AuthPage/SignIn' });
      }
    }

    return {
      hiddenHeader:false,
      // api setting
      setDebugMode: true,
      apiDebug: false,
      apiName: '',
      perPage: 3, //筆數
      pageMode: true,
      perPageOptions: [5, 10, 25, 50, 75, 100],
      // data
      userInfo:{coin:0 , point:0},
      token:null,
      nid,
      // function
      goToPage,
      chkLogin,
    };
  },
  created() {
  },
  mounted() {
    oFrame.initMD();
  },
  methods: {
  }
};
</script>
